import { BudgetSummary } from "./types";

interface SummaryCardsProps {
  summary: BudgetSummary;
  loading?: boolean;
}

const SummaryCards = ({ summary, loading = false }: SummaryCardsProps) => {
  const getBorderColor = (key: keyof BudgetSummary): string => {
    switch (key) {
      case "enviados":
        return "#6B7280";
      case "alterados":
      case "contraproposta":
        return "#F97316";
      case "aceito":
      case "concluido":
        return "#10B981";
      case "recusado":
        return "#EF4444";
      default:
        return "#6B7280";
    }
  };

  const cards = [
    { key: "enviados" as keyof BudgetSummary, label: "Enviados para análise" },
    { key: "alterados" as keyof BudgetSummary, label: "Alterados" },
    { key: "contraproposta" as keyof BudgetSummary, label: "Contraproposta" },
    { key: "aceito" as keyof BudgetSummary, label: "Aprovados pelo Volks|total" },
    { key: "recusado" as keyof BudgetSummary, label: "Recusado" },
    { key: "concluido" as keyof BudgetSummary, label: "Aprovados pelo cliente" },
  ];

  return (
    <div className="margin-bottom-20">
      <div className="flex gap-4 items-stretch w-full">
        {cards.map((card) => (
          <div
            key={card.key}
            className="bg-white rounded-lg shadow-sm border-l-4 flex-1 p-5 flex flex-col justify-start items-start"
            style={{
              borderLeftColor: getBorderColor(card.key),
            }}
          >
            <div className="w-full flex flex-col gap-3">
              <div className="text-size-14 font-normal text-gray-600 text-left leading-tight">
                {card.label}
              </div>
              <div className="text-[36px] font-bold text-gray-900 text-left leading-none font-sans">
                {loading ? "-" : summary[card.key]}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SummaryCards;
